import React from 'react';
import { RegionProvider, useRegionContext } from './RegionContext';
import { FilterProvider, useFilterContext } from './FilterContext';
import { AptDataProvider, useAptDataContext } from './AptDataContext';
import { SortProvider, useSortContext } from './SortContext';

export const AptMetrixProvider = ({ children }) => (
  <RegionProvider>
    <FilterProvider>
      <AptDataProvider>
        <SortProvider>
          {children}
        </SortProvider>
      </AptDataProvider>
    </FilterProvider>
  </RegionProvider>
);

export { useRegionContext } from './RegionContext';
export { useFilterContext } from './FilterContext';
export { useAptDataContext } from './AptDataContext';
export { useSortContext } from './SortContext';
